import { FC, useState } from 'react';
import { Form, Formik } from 'formik';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import AuthWrapper from '../../common/AuthWrapper';
import CustomInput from '../../common/CustomInput';
import CustomButton from '../../common/CustomButton';
import { useIsMobile } from '../../hooks/useWindowWidth';
import { useResetPasswordInitiateMutation } from '../../store/services/authApi';

import styles from './ForgotPassword.module.scss';

const ForgotPassword: FC = () => {
  const isMobile = useIsMobile();
  const [resetPasswordInitiate] = useResetPasswordInitiateMutation();

  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState('');
  const [resErrors, setResErrors] = useState<{ attr: string | null; code: string; detail: string }[] | null>(null);

  const initialValues = {
    email: '',
  };

  const handleSubmit = async (values: { email: string }) => {
    try {
      await resetPasswordInitiate({ email: values.email });
      setResErrors(null);
      setSuccess(true);
      setEmail(values.email);
    } catch (error) {
      console.error(error);
      setSuccess(false);
      setEmail('');
      setResErrors((error as any)?.data?.errors || null);
    }
  };

  const formikValidate = (values: { email: string }) => {
    const errors: { email?: string } = {};
    if (!values.email) {
      errors.email = 'Email is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = 'Invalid email address';
    }
    return errors;
  };
  console.log(success);
  return (
    <AuthWrapper btnName="Sign In">
      <Box className={styles.contentWrapper}>
        <Box className={styles.loginContent}>
          <Typography
            variant={`${isMobile ? 'h6Bold' : 'h5Bold'}`}
            className={!success ? styles.title : ''}
          >
            {success ? 'Check your inbox' : 'Forgot your password?'}
          </Typography>
          {success && <Typography color="#5E6A81">We’ve sent a password reset link to</Typography>}
          {success && (
            <Typography
              color="#5E6A81"
              fontWeight={600}
            >
              {email}
            </Typography>
          )}
          <Formik
            initialValues={initialValues}
            validate={formikValidate}
            onSubmit={handleSubmit}
          >
            {({ values, errors, handleChange, isSubmitting }) => (
              <Form className={styles.loginForm}>
                {!success && (
                  <CustomInput
                    inputType="email"
                    inputName="email"
                    inputLabel="Email"
                    value={values.email}
                    error={errors.email}
                    customClass={styles.customInput}
                    onChange={handleChange}
                  />
                )}
                <CustomButton
                  btnType="submit"
                  variant={success ? 'outlined' : 'contained'}
                  customClass={success ? styles.customButtonOutlined : styles.customButton}
                  disabled={isSubmitting}
                >
                  {success ? 'Resend Link' : 'Reset Password'}
                </CustomButton>
                {resErrors &&
                  resErrors.map((error, index) => (
                    <Typography
                      key={index}
                      variant="h12"
                      sx={{ color: '#C8102E' }}
                    >
                      {error.detail}
                    </Typography>
                  ))}
              </Form>
            )}
          </Formik>

          {!success && (
            <Box className={styles.signInQuestion}>
              <Typography
                variant="h11"
                className={styles.signInQuestionText}
              >
                Remembered your password?
              </Typography>
              <Link
                to="/"
                className={styles.signInLink}
              >
                <Typography variant="h11Semibold">Log In</Typography>
              </Link>
            </Box>
          )}
        </Box>
        <Box className={styles.termsAndConditions}>
          <Typography
            variant="h11"
            sx={{ textAlign: 'center' }}
          >
            By signing up, you understand and agree with TravGenius'
          </Typography>
          <Typography variant="h11">
            <a
              href="/terms-privacy/TravGenius Terms and Conditions MAIN.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#222B3A' }}
            >
              Terms & Conditions
            </a>
            <span> and </span>
            <a
              href="/terms-privacy/TravGenius Privacy Policy (GDPR & CCPA) MAIN.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#222B3A' }}
            >
              Privacy Policy
            </a>
          </Typography>
        </Box>
      </Box>
    </AuthWrapper>
  );
};

export default ForgotPassword;
